'use es6';

import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Section } from 'foundations-components/transitional/components/Section';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { H4 } from 'foundations-components/transitional/components/H4';
import { useDispatch } from 'react-redux';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { useMemo } from 'react';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { WarningIcon } from 'foundations-assets/icons/components/WarningIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Issues = ({
  issues,
  iconBgColor,
  issueLabel,
  onIssueClick
}) => {
  if (issues.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Section, {
    children: [/*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(MediaObject, {
        align: "center",
        itemLeft: /*#__PURE__*/_jsx(IconCircle, {
          icon: WarningIcon,
          size: "100",
          color: "icon-core-on-fill-default",
          backgroundColor: iconBgColor
        }),
        marginInlineStart: "800",
        children: /*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: issueLabel
          })
        })
      })
    }), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(List, {
        ordered: true,
        styled: true,
        children: issues.map((issue, index) => {
          const {
            node
          } = issue;
          return /*#__PURE__*/_jsx(ListItem, {
            marginInlineStart: "200",
            marginInlineEnd: "200",
            children: /*#__PURE__*/_jsx(Link, {
              use: "unstyled",
              onClick: () => onIssueClick(issue),
              children: node
            }, index)
          }, index);
        })
      })
    })]
  });
};
const EmptyState = () => {
  return /*#__PURE__*/_jsxs(Text, {
    as: "div",
    textAlign: "center",
    padding: "600",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "success-green",
      width: "30%"
    }), /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "400",
      marginBlockEnd: "400",
      as: "div",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "warningsAndSuggestionsPanel.emptyState.title"
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "warningsAndSuggestionsPanel.emptyState.body"
        })
      })]
    })]
  });
};
const WarningsAndSuggestionsPanel = ({
  errorLabels,
  warningLabels,
  infoLabels,
  onIssueClick,
  onClose
}) => {
  const dispatch = useDispatch();
  const issueClickHandler = ({
    target,
    onClickData
  }) => {
    dispatch(onIssueClick(target, onClickData));
  };
  const shouldShowEmptyState = useMemo(() => {
    if (errorLabels && errorLabels.length > 0) {
      return false;
    }
    if (warningLabels && warningLabels.length > 0) {
      return false;
    }
    if (infoLabels && infoLabels.length > 0) {
      return false;
    }
    return true;
  }, [errorLabels, warningLabels, infoLabels]);
  return /*#__PURE__*/_jsxs(Panel, {
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "approvals.warningsAndSuggestions"
        })
      })
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsx(View, {
        marginBlockStart: "800",
        as: "div",
        children: shouldShowEmptyState ? /*#__PURE__*/_jsx(EmptyState, {}) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Issues, {
            issues: errorLabels,
            iconBgColor: "border-alert-default",
            issueLabel: "epIssueButton.errorLabel",
            onIssueClick: issueClickHandler
          }), /*#__PURE__*/_jsx(Issues, {
            issues: warningLabels,
            iconBgColor: "border-caution-default",
            issueLabel: "epIssueButton.warningLabel",
            onIssueClick: issueClickHandler
          }), /*#__PURE__*/_jsx(Issues, {
            issues: infoLabels,
            iconBgColor: "border-info-default",
            issueLabel: "epIssueButton.infoLabel",
            onIssueClick: issueClickHandler
          })]
        })
      })
    })]
  });
};
export default WarningsAndSuggestionsPanel;